import { useRef, useState, useEffect } from 'react';
import { Button, Col, Form, InputGroup, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import userService from '../../service/userService';
import toast from '../../service/toaster';
import './auth.css';

const Register = () => {
  const navigate = useNavigate();
  const googleBtnRef = useRef(null);
  const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '489075978798-led1v9pogg4htnqqonmp0j1ra4j9cbdh.apps.googleusercontent.com';
  const [passwordType, setPasswordType] = useState('password');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [userinfo, setUserinfo] = useState({
    email: '',
    password: ''
  });

  const userinfoHandler = (event) => {
    setUserinfo((creds) => ({ ...creds, [event.target.name]: event.target.value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else if (userinfo.password === userinfo.confirmPassword) {
      userService
        .register(userinfo)
        .then((resp) => {
          toast.success(resp.message);
          navigate('/login');
        })
        .catch((err) => {
          toast.error(err.message);
          console.log(err);
        });
    }
    setFormSubmitted(true);
  };

  const loadGoogleScript = () => {
    return new Promise((resolve, reject) => {
      if (window.google?.accounts?.id) return resolve();
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.defer = true;
      script.onload = resolve;
      script.onerror = reject;
      document.body.appendChild(script);
    });
  };

  const handleGoogleCredentialResponse = async (response) => {
    const idToken = response?.credential;
    if (!idToken) return;
    try {
      const resp = await userService.googleAuth({ idToken });
      toast.success(resp.message || 'Signed up with Google');
      localStorage.setItem('token', resp.data.token);
      localStorage.setItem('userDetails', JSON.stringify(resp.data));
      navigate('/');
    } catch (err) {
      toast.error(err.message);
    }
  };

  useEffect(() => {
    loadGoogleScript()
      .then(() => {
        if (!window.google || !GOOGLE_CLIENT_ID) return;
        window.google.accounts.id.initialize({
          client_id: GOOGLE_CLIENT_ID,
          callback: handleGoogleCredentialResponse
        });
        if (googleBtnRef.current) {
          window.google.accounts.id.renderButton(googleBtnRef.current, { theme: 'outline', size: 'large', width: 220 });
        }
      })
      .catch(() => console.warn('Google script failed to load'));
  }, []);

  return (
    <div className="auth-page">
      <div className="wrapper auth-wrapper">
        <Form noValidate onSubmit={handleSubmit} className="login auth-card">
          <div className="body-str">
            <h2 className="text-center auth-brand">
              <img src={require('../../assets/cricket-player.png')} alt="Cricket Prediction Logo" />
              <span>Cricket Prediction</span>
            </h2>
            <hr />
            <h4 className="text-center">Registration</h4>

            <Row className="mb-2">
              <Form.Group as={Col} md="16" controlId="validationFirstName">
                <Form.Label>First name</Form.Label>
                <InputGroup hasValidation>
                  <InputGroup.Text id="inputGroupPrepend">
                    <span>
                      <img src={require('../../assets/icons8-badge-24.png')} height={15} width={10} alt="First name icon" />
                    </span>
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    name="firstName"
                    placeholder="First name"
                    onChange={userinfoHandler}
                    aria-describedby="inputGroupPrepend"
                    required
                    isInvalid={!userinfo?.firstName && formSubmitted}
                  />
                  <Form.Control.Feedback type="invalid">Please provide first name.</Form.Control.Feedback>
                </InputGroup>
              </Form.Group>
            </Row>

            <Row className="mb-2">
              <Form.Group as={Col} md="16" controlId="validationLastName">
                <Form.Label>Last name</Form.Label>
                <InputGroup hasValidation>
                  <InputGroup.Text id="inputGroupPrepend">
                    <span>
                      <img src={require('../../assets/icons8-badge-24.png')} height={15} width={10} alt="Last name icon" />
                    </span>
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    name="lastName"
                    placeholder="Last name"
                    onChange={userinfoHandler}
                    aria-describedby="inputGroupPrepend"
                    required
                    isInvalid={!userinfo?.lastName && formSubmitted}
                  />
                  <Form.Control.Feedback type="invalid">Please provide last name.</Form.Control.Feedback>
                </InputGroup>
              </Form.Group>
            </Row>

            <Row className="mb-2">
              <Form.Group as={Col} md="16" controlId="validationEmail">
                <Form.Label>Email</Form.Label>
                <InputGroup hasValidation>
                  <InputGroup.Text id="inputGroupPrepend">
                    <span className="fa fa-user"></span>
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    name="email"
                    placeholder="Email"
                    onChange={userinfoHandler}
                    aria-describedby="inputGroupPrepend"
                    required
                    isInvalid={!userinfo.email && formSubmitted}
                  />
                  <Form.Control.Feedback type="invalid">Please provide a valid email.</Form.Control.Feedback>
                </InputGroup>
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} md="16" controlId="validationPassword">
                <Form.Label>New password</Form.Label>
                <InputGroup hasValidation>
                  <InputGroup.Text id="inputGroupPrepend">
                    <span className="fa fa-lock"></span>
                  </InputGroup.Text>
                  <Form.Control
                    type={passwordType}
                    name="password"
                    onChange={userinfoHandler}
                    placeholder="Password"
                    required
                    isInvalid={!userinfo.password && formSubmitted}
                  />
                  <Form.Control.Feedback type="invalid">Please provide password.</Form.Control.Feedback>
                </InputGroup>
              </Form.Group>
            </Row>

            {userinfo.password && (
              <Row className="mb-3">
                <Form.Group md="16">
                  <Form.Label>Confirm Password</Form.Label>
                  <InputGroup hasValidation>
                    <InputGroup.Text id="inputGroupPrepend">
                      <span className="fa fa-lock"></span>
                    </InputGroup.Text>
                    <Form.Control
                      type={passwordType}
                      name="confirmPassword"
                      onChange={userinfoHandler}
                      placeholder="Confirm Password"
                      isInvalid={userinfo.password !== userinfo.confirmPassword}
                      required
                    />
                    <Form.Control.Feedback type="invalid">Password did not match.</Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>
              </Row>
            )}

            <Form.Check
              type="checkbox"
              id="default-checkbox"
              label="Show Password"
              className="auth-check"
              onClick={() => {
                setPasswordType((prev) => (prev === 'password' ? 'text' : 'password'));
              }}
            />

            <div className="auth-submit-wrap">
              <Button type="submit">Register</Button>
              <div>
                <button type="button" className="auth-link-btn" onClick={() => navigate('/login')}>
                  Already Registered?
                </button>
              </div>
            </div>

            <div className="auth-oauth">
              <div className="auth-oauth-note">or sign up with</div>
              <div ref={googleBtnRef} style={{ marginTop: '8px', display: 'flex', justifyContent: 'center' }} />
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default Register;
